import { useEffect } from 'react';

export const useCriticalData = getData => {
    useEffect(() => {
        const timer = setInterval(() => getData(), 4.5e4);

        return () => clearInterval(timer);
    }, []);
};
